import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCompactNumber } from '../../../utils/numberFormatters';
import { CTA_PILL_BASE, CTA_COLOR_PRESETS } from './EpkCtaButton';

// Reuses EpkCtaButton's geometry and its pink preset verbatim, so the two pills
// stay dimensionally identical and this never introduces a second pink hex.
const PILL_CLASS = `${CTA_PILL_BASE} tw-gap-2 tw-border-none ${CTA_COLOR_PRESETS.pink.button}`;

export default function WaitlistCtaButton({ epkInfo, isEditMode, hasJoinedWaitlist, totalCount, onClick }) {
  const { t } = useTranslation();

  // Hides whenever the waitlist is off, in edit mode too -- the preview always
  // mirrors exactly what a public visitor would see, never a "here's the slot even
  // though it's disabled" state that could be mistaken for it being live.
  if (!epkInfo?.waitlistConfig?.enabled) return null;

  const label = hasJoinedWaitlist ? t('Waitlist Status') : t('Join Waitlist');

  return (
    <button
      type="button"
      onClick={isEditMode ? undefined : onClick}
      disabled={isEditMode}
      title={label}
      className={`${PILL_CLASS} ${isEditMode ? 'tw-opacity-40 tw-grayscale tw-cursor-not-allowed' : 'tw-cursor-pointer'}`}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tw-shrink-0">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
      <span className="tw-truncate">{label}</span>
      {totalCount > 0 && (
        <span className="tw-shrink-0 tw-text-[11px] tw-font-bold tw-opacity-75 tw-bg-[rgba(87,0,51,0.12)] tw-px-2 tw-py-0.5 tw-rounded-full">
          {t('{{joined}} joined', { joined: formatCompactNumber(totalCount) })}
        </span>
      )}
    </button>
  );
}
